import React from 'react';

const QaIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 145 145"
    version="1.1"
    className={className}
    width="1em"
    height="1em"
  >
    <path
      d="M16.95,86.38c-.84,0-1.51-.69-1.52-1.53-.14-14.52-.09-28.72-.04-36.4.03-4.33,1.16-8.57,3.3-12.34,5.47-9.62,15.43-19.25,33.85-18.54,18.58.72,31.17,9.57,32.68,28.54.55,6.88.33,16.17-1.5,21.06-2.97,7.94-9.71,19.25-29.35,18.99-8.8-.12-24.32.36-37.42.21Z"
      fill="#fff"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="8"
    />
    <path
      d="M139.32,117.71c.84,0,1.51-.69,1.52-1.53.14-14.52.09-28.72.04-36.4-.03-4.33-1.16-8.57-3.3-12.34-5.47-9.62-15.43-19.25-33.85-18.54-18.58.72-31.17,9.57-32.68,28.54-.55,6.88-.33,16.17,1.5,21.06,2.97,7.94,9.71,19.25,29.35,18.99,8.8-.12,24.32.36,37.42.21Z"
      fill="#fff"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="8"
    />
    <text
      x="32.95"
      y="65.76"
      fill="currentColor"
      fontSize="36"
      fontFamily="'Hiragino Kaku Gothic StdN', sans-serif"
    >
      Q
    </text>
    <text
      x="93.22"
      y="95.38"
      fill="currentColor"
      fontSize="36"
      fontFamily="'Hiragino Kaku Gothic StdN', sans-serif"
    >
      A
    </text>
  </svg>

  );
};

export default QaIcon;
